import { ref, type Ref } from 'vue';
import type { TTabbedDetailDialogCloseReason } from './tabbedDetailDialog.types';

export interface ITabbedDetailDialogCloseLifecycleOptions {
  beforeClose: (reason: TTabbedDetailDialogCloseReason) => boolean | Promise<boolean>;
  hide: (reason: TTabbedDetailDialogCloseReason) => Promise<void>;
  isCloseDisabled: () => boolean;
  isRendered: () => boolean;
}

export interface ITabbedDetailDialogCloseLifecycleComposable {
  closePending: Ref<boolean>;
  requestClose: (reason?: TTabbedDetailDialogCloseReason) => Promise<boolean>;
}

export const useTabbedDetailDialogCloseLifecycle = (
  options: ITabbedDetailDialogCloseLifecycleOptions,
): ITabbedDetailDialogCloseLifecycleComposable => {
  const closePending = ref(false);

  const requestClose = async (reason: TTabbedDetailDialogCloseReason = 'programmatic'): Promise<boolean> => {
    if (options.isCloseDisabled() || closePending.value || !options.isRendered()) return false;

    closePending.value = true;
    try {
      if (!(await options.beforeClose(reason))) return false;
      await options.hide(reason);
      return true;
    } finally {
      closePending.value = false;
    }
  };

  return { closePending, requestClose };
};
